import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".5",
      "stroke-width": "1.5",
      d: "m10.804 14.104-.825.825a2.917 2.917 0 0 1-4.125-4.125l.825-.825m7.425.825.825-.825a2.917 2.917 0 0 0-4.125-4.125l-.825.825m-1.63 5.754 4.084-4.083"
    }, null, -1)
  ]))]))
}
export default { render: render }